<template>
  <div>
    <Navbar />
    <div class="mainPostagensEscreva">
      <b-row class="linha" align-h="center">
        <b-col cols="10" md="8" lg="8">
          <h1 class="title">postagem anônima</h1>
          <p class="textoPrincipal">
            As postagens anônimas tem como objetivo a criação de um espaço para
            compartilhamento de relatos e mensagens, com a possibilidade total de manter o
            anonimato! Sua postagem será enviada para a administração, e passará por
            aprovação. Após aprovada, ela aparecerá aqui junto com outras postagens!
          </p>
        </b-col>
      </b-row>
      <EscrevaAqui />
    </div>
    <Footer />
  </div>
</template>

<script>
import EscrevaAqui from '@/components/EscrevaPostagens.vue';
import Navbar from '@/components/home/navbar.vue';
import Footer from '@/components/Footer.vue';
import backUrl from '@/utils/backUrl.js';
import { seo } from '@/utils/seo.js';
export default {
  components: {
    EscrevaAqui,
    Navbar,
    Footer,
  },
  metaInfo() {
    return seo(
      'Postagem Anônima',
      'Escreva aqui sua postagem anônima para o Projeto Niara',
      `${this.backUrl}/download-file/logo/ProjetoNiaraLogo.png`,
      this.thisUrl,
      'website',
    );
  },
  data() {
    return {
      thisUrl: window.location.href,
      backUrl: backUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.mainPostagensEscreva {
  padding-top: 3.5rem;
  margin-top: 3rem;
  padding-bottom: 10vh;
  background-color: #fffaf4;
}
.linha.row {
  margin: 0;
}
.title {
  font-family: 'Yeseva One', cursive;
  font-weight: 400;
  font-size: 5rem;
  color: #363636;
  margin-bottom: 2rem;
  padding-top: 0.2rem;
}
.textoPrincipal {
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 1.2rem;
  color: #363636;
  margin-bottom: 2rem;
}
@media (min-width: 1024px) and (max-width: 1024px) {
  .mainPostagensEscreva {
    height: 66vh;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .title {
    font-size: 3rem;
    color: #363636;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .title {
    font-size: 2.5rem;
    color: #363636;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .title {
    font-size: 2.5rem;
    color: #363636;
  }
}
@media (max-width: 320px) {
  .title {
    font-size: 2.5rem;
    color: #363636;
  }
}
@media (max-width: 280px) {
  .title {
    font-size: 2rem;
    color: #363636;
  }
}
</style>
